import React, { ChangeEvent, ReactElement, SetStateAction } from 'react';
import { useState, useEffect } from 'react';

import { TableRowData } from '../../../../types/common.types';

import { isEmpty } from '../../../../utils/util';

import { ReactComponent as SearchIcon } from '../../../../resources/icons/search.svg';

import './table-filter.scss';

type Props = {
  data: TableRowData[];
  setFilteredData: React.Dispatch<SetStateAction<TableRowData[]>>;
  setCurrentPage: React.Dispatch<SetStateAction<number>>;
};

const TableFilter = ({ data, setFilteredData, setCurrentPage }: Props): ReactElement => {
  const [filterValue, setFilterValue] = useState<string>('');

  useEffect((): void => {
    if (isEmpty(data)) return;

    if (!filterValue) {
      setFilteredData(data);
      return;
    }

    const filteredData: TableRowData[] = [];
    data.forEach((object: TableRowData): void => {
      for (const property in object) {
        if (object[property]?.toString().toLowerCase().includes(filterValue.toLowerCase())) {
          filteredData.push(object);
          return;
        }
      }
    });

    setCurrentPage(0);
    setFilteredData(filteredData);
  }, [data, filterValue, setFilteredData, setCurrentPage]);

  return (
    <div className="table-filter">
      <SearchIcon fill="#0f3a5d" />
      <input
        className="table-filter__input"
        value={filterValue}
        onChange={({ target }: ChangeEvent<HTMLInputElement>): void => setFilterValue(target.value)}
        data-testid="table-filter"
      />
    </div>
  );
};

export default TableFilter;
